import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/datasources/connectInspectFile';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

// Stage + detect a single file so the field mapper can open before importing.
function* operation(action) {
  try {
    const form = new FormData();
    form.append('file', action.payload.file);
    const res = yield call(
      axios.post,
      `${config.API_URL}/ingestion/connect/inspect-file`,
      form,
      { headers: { ...getLocalUser(), 'Content-Type': 'multipart/form-data' } },
    );
    yield put(fetchSuccess(res.data?.data || res.data));
  } catch (error) {
    yield put(ErrorAction(error));
    yield put(fetchFailure(error.response?.data?.error || error.message || 'Could not read that file.'));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
